import Swal from "sweetalert2";
type Props = {
  title?: string;
  text?: string;
  confirmButtonText?: string;
};
export const errorAlert = (options?: Props) => {
  return Swal.fire({
    title: options?.title ?? "Erro inesperado",
    text: options?.text ?? "Tente novamente mais tarde",
    icon: "error",
    confirmButtonColor: "#103680",
    confirmButtonText: options?.confirmButtonText ?? "Ok",
  });
};
